import Vue from 'vue';
import VueI18n from 'vue-i18n';

import vien from './i18n/vi/en.json';
import vivn from './i18n/vi/vi.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'vi', // set default locale to Vietnamese
  messages: {
    en: {
      lang: vien,
    },
    vi: {
      lang: vivn,
    },
  },
});
